<template>
  <div class="home-section strict">
    <div class="home-section-inner">
      <div class="head flex flex-center flex-column flex-middle">
        <div class="head-name">热门服务推荐</div>
        <div class="head-tips">Recommended Popular Services</div>
      </div>
      <div>
        <div v-for="(cate, index) in parentCates" :key="cate.serviceCategoryId">
          <div class="title flex flex-center flex-middle">
            <div class="title-name flex flex-center flex-middle">
              {{ cate.serviceCategoryName }}
            </div>
          </div>
          <div class="content">
            <Devices :cateId="cate.serviceCategoryId" />
            <Labs
              :cateId="cate.serviceCategoryId"
              :bg="$oss('images/home/mall/bg' + (index + 1) + '.png')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryKind } from "@/api/mall";
import Labs from "./Labs.vue";
import Devices from "./Devices.vue";
export default {
  name: "modular_server_mall",
  components: {
    Labs,
    Devices,
  },
  data() {
    return {
      parentCates: [],
      page: {
        pageIndex: 1,
        pageSize: 5,
      },
      englishMap: ["DEVICE SERVICE", "PROJECT SERVICE", "PACKAGE SERVICE"],
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    async getCategory() {
      // 获取顶级分类
      const pData = await this.$axios.get(queryKind, {
        superCategoryId: 0,
      });
      this.parentCates = pData;
    },
    moreClick(cate) {
      this.$jump.push({
        name: "mallStrict",
        query: { cateId: cate.serviceCategoryId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
@import "@/style/common";
.head {
  padding-bottom: 0 !important;
}
.title {
  padding: 40px 0;
  &-name {
    height: 60px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    background: url($oss-url + "home/title-bg/title-bg-3.png") no-repeat center
      center / contain;
  }
}
.content {
  display: grid;
  gap: 20px;
  grid-template-columns: calc(100% - 236px) 216px;
}
.strict {
  background: url($oss-url + "home/bg/bg-4.png") no-repeat 0 0 / 100% 1000px,
    url($oss-url + "home/bg/bg-5.png") no-repeat 0 1000px / 100% 1000px,
    url($oss-url + "home/bg/bg-4.png") no-repeat 0 2000px / 100% 1000px;
  background-color: rgb(248, 251, 255);
}
</style>
